export default __webpack_public_path__ + "static/media/dentalMenuPremiumHero.9b17acc5.jpg";